import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import homeBg from "../assets/images/home.jpeg";

export default function Login() {
  const { t } = useTranslation("global");
  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await login(email, password);
      navigate("/profile", { replace: true });
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log(errorCode, errorMessage);

      if (errorCode === "auth/wrong-password") {
        setError(t("Alert1.text"));
      } else if (errorCode === "auth/user-not-found") {
        setError(t("Alert2.text"));
      } else if (errorCode === "auth/network-error") {
        setError(t("Alert3.text"));
      } else if (errorCode === "auth/invalid-credential") {
        setError(t("Alert4.text"));
      } else {
        setError(t("Alert5.text") + errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex items-center justify-center w-full relative h-screen bg-center bg-no-repeat bg-cover"
      style={{ backgroundImage: `url(${homeBg})` }}
    >
      <div className="bg-gray-800/50 bg-blend-multiply shadow-md rounded-lg px-8 py-6 max-w-md backdrop-filter backdrop-blur-md w-full">
        <h1 className="text-2xl font-bold text-center mb-4 dark:text-gray-200">
          {t("Login.text")}
        </h1>

        {error && (
          <div
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4"
            role="alert"
          >
            <span className="block sm:inline">{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-300 mb-2"
            >
              {t("Email.text")}
            </label>
            <input
              type="email"
              id="email"
              className="w-full py-3 px-3 rounded-lg bg-gray-700/80 border border-gray-600 text-gray-400 font-semibold focus:border-[#fcab21] focus:outline-none"
              placeholder="flyxom@email.com"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="mb-4">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-300 mb-2"
            >
              {t("Password.text")}
            </label>
            <input
              type="password"
              id="password"
              className="w-full py-3 px-3 rounded-lg bg-gray-700/80 border border-gray-600 text-gray-400 font-semibold focus:border-[#fcab21] focus:outline-none"
              placeholder={t("Password_1.text")}
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="mt-2 text-right">
              <NavLink
                to={"/passwordreset"}
                className="text-xs text-white hover:text-[#fcab21] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                {t("Forgot_Password.text")}
              </NavLink>
            </div>
          </div>
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center">
              <input
                type="checkbox"
                id="remember"
                className="h-4 w-4 rounded border-[#fcab21] focus:ring-[#fcab21]"
              />
              <label
                htmlFor="remember"
                className="ml-2 block text-sm text-gray-300"
              >
                {t("Remember.text")}
              </label>
            </div>
            <NavLink
              to={"/register"}
              className="text-xs text-gray-300 hover:text-[#fcab21] focus:outline-none"
            >
              {t("Create_Account.text")}
            </NavLink>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-xl text-sm md:text-base text-white font-semibold bg-[#fcab21] hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#fcab21] disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
          >
            {loading ? "Loading..." : t("Login.text")}
          </button>
        </form>
      </div>
    </div>
  );
}
